import { Injectable } from '@angular/core';
// Para poder generar la imagen del código de barras fue necesario instalar "io-barcode"
import ioBarcode from 'io-barcode';

@Injectable()
export class OxxoService {

    constructor() { }

    public generarCodigoOxxo(cotizacion:any){
        let fechaTerminaOxxo = new Date(cotizacion.fechaDeCreacion + (60 * 60 * 24 * 1000 * 15));
        let pasoUnoDias = fechaTerminaOxxo.toISOString().substring(fechaTerminaOxxo.toISOString().indexOf('-')+1,fechaTerminaOxxo.toISOString().length);
        let pasoDosDias = pasoUnoDias.substring(pasoUnoDias.indexOf('-')+1, pasoUnoDias.indexOf('T'));
        let fechaExpira = pasoDosDias + fechaTerminaOxxo.toISOString().substring(5,7) + fechaTerminaOxxo.toISOString().substring(2,4);
        let numeroCotizacion = cotizacion.idTrosten.match(  /\d+/g )[0].substring(2);                
        while(numeroCotizacion.length<5){
            numeroCotizacion = '0'+numeroCotizacion;
        }

        let numeroOxxo = '05' + numeroCotizacion + fechaExpira;

        let arregloNumeros = numeroOxxo.split('');
        let suma = 0;
        let multiplicador = 1;
        arregloNumeros.forEach(numero => {
            suma+= parseInt(numero) * multiplicador;
            multiplicador++;
            if(multiplicador>9){
                multiplicador = 1;
            }
        });
        let numeroVerificador = suma % 10;
        return numeroOxxo + numeroVerificador;
    }

    public crearCodigoDeBarras(referencia:string){
        let canvas = ioBarcode.CODE128C(referencia, {
            width: 1,
            height: 60,
            displayValue : true
        });
        return canvas.toDataURL('image/png');
    }

}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/oxxo.service.ts